/* ScandyLand faceted grid.

   Facet values are derived from the rendered cards, not from Liquid's
   collection.all_tags / all_vendors. On the catch-all collection those
   return an incomplete list (we saw a single tag for a five-tag catalogue),
   which silently drops filters. Reading the DOM can never disagree with
   what is actually on the page.

   Within a group values OR together; across groups they AND.
   BUBS + S-Marke + Sour => sour items from either brand. */
(function () {
  var n = function (v) { return (v || '').trim().toLowerCase(); };

  function init(root) {
    var cards = [].slice.call(root.querySelectorAll('.sc-card'));
    if (!cards.length) return;

    var tabs = [].slice.call(root.querySelectorAll('[data-tab]'));
    var countEl = root.querySelector('[data-count]');
    var clearEl = root.querySelector('[data-clear]');
    var noneEl = root.querySelector('[data-none]');
    var showCounts = root.getAttribute('data-counts') === 'true';

    var meta = cards.map(function (c) {
      return {
        el: c,
        vendor: (c.getAttribute('data-vendor') || '').trim(),
        tags: (c.getAttribute('data-tags') || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean)
      };
    });

    function tally(pick) {
      var out = {};
      meta.forEach(function (m) {
        pick(m).forEach(function (v) {
          if (!v) return;
          out[v] = (out[v] || 0) + 1;
        });
      });
      return Object.keys(out).sort(function (a, b) {
        return a.localeCompare(b);
      }).map(function (k) { return { label: k, count: out[k] }; });
    }

    function fill(group, values) {
      var host = root.querySelector('[data-pills="' + group + '"]');
      if (!host) return;
      host.innerHTML = '';
      values.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sc-pill';
        b.setAttribute('data-facet', group);
        b.setAttribute('data-value', v.label);
        b.setAttribute('aria-pressed', 'false');
        b.textContent = v.label;
        if (showCounts) {
          var s = document.createElement('span');
          s.className = 'sc-pill__n';
          s.textContent = v.count;
          b.appendChild(s);
        }
        host.appendChild(b);
      });
    }

    fill('brand', tally(function (m) { return [m.vendor]; }));
    fill('flavour', tally(function (m) { return m.tags; }));

    var pills = [].slice.call(root.querySelectorAll('[data-facet]'));

    function chosen(g) {
      return pills.filter(function (p) {
        return p.getAttribute('data-facet') === g && p.getAttribute('aria-pressed') === 'true';
      }).map(function (p) { return n(p.getAttribute('data-value')); });
    }

    function apply() {
      var b = chosen('brand'), f = chosen('flavour'), shown = 0;
      meta.forEach(function (m) {
        var okB = !b.length || b.indexOf(n(m.vendor)) > -1;
        var okF = !f.length || f.some(function (t) { return m.tags.map(n).indexOf(t) > -1; });
        var vis = okB && okF;
        m.el.hidden = !vis;
        if (vis) shown++;
      });
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' treat' : ' treats');
      if (clearEl) clearEl.hidden = !(b.length || f.length);
      if (noneEl) noneEl.hidden = shown !== 0;
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        p.setAttribute('aria-pressed', p.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        apply();
      });
    });

    if (clearEl) {
      clearEl.addEventListener('click', function () {
        pills.forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        apply();
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var key = t.getAttribute('data-tab');
        tabs.forEach(function (o) { o.setAttribute('aria-selected', String(o === t)); });
        [].slice.call(root.querySelectorAll('[data-panel]')).forEach(function (p) {
          p.hidden = p.getAttribute('data-panel') !== key;
        });
      });
    });

    apply();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-facets]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
